import { render, staticRenderFns } from "./SidebarBoxHighlightSpecial.vue?vue&type=template&id=c79d1522&scoped=true&"
import script from "./SidebarBoxHighlightSpecial.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxHighlightSpecial.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxHighlightSpecial.vue?vue&type=style&index=0&id=c79d1522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79d1522",
  null
  
)

export default component.exports